import axios from 'axios'
import urls from '@/urls'

let store = {
  namespaced: true,
  state: {
    product: {
      sku: null,
      name: null,
      price: null,
      originalPrice: null,
      version: null,
      photoUrl: null,
      paymentUrl: null
    },
    error: null,
    coupon: null,
    show: false
  },
  mutations: {
    CLEAR_PRODUCT (state) {
      state.product = {
        sku: null,
        name: null,
        price: null,
        originalPrice: null,
        version: null,
        photoUrl: null,
        paymentUrl: null
      }
      state.coupon = null
    },
    UPDATE_COUPON (state, coupon) {
      state.coupon = coupon
    },
    SHOW_BUY_MODAL (state) {
      state.show = true
    },
    SHOW_QR (state, payload) {
      let { price, paymentUrl, originalPrice } = payload
      state.product.price = price
      state.product.paymentUrl = paymentUrl
      state.product.originalPrice = originalPrice
    },
    HIDE_BUY_MODAL (state) {
      state.show = false
    },
    HIDE_QR (state) {
      state.product.paymentUrl = null
      state.product.price = state.product.originalPrice
      state.product.originalPrice = null
    },
    SET_PRICE (state, payload) {
      state.product.price = payload.price
      state.product.upgradePrice = payload.upgradePrice
      state.product.originalPrice = payload.originalPrice
    },
    SET_INFO (state, payload) {
      let { product } = payload
      state.product = { ...state.product, ...product }
    },
    SET_ERROR (state, error) {
      state.error = error
    },
    CLEAR_ERROR (state, error) {
      state.error = null
    }
  },
  actions: {
    async showBuyModal ({ dispatch, commit }, { sku, price, versionText, img, name }) {
      commit('CLEAR_PRODUCT')
      commit('CLEAR_ERROR')
      commit('SET_INFO', {
        product: {
          name: name === null ? null : name,
          version: versionText,
          sku,
          photoUrl: img
        }
      })
      await dispatch('getPrice')
      commit('SHOW_BUY_MODAL')
    },
    async getCheckoutQr ({ commit, state, rootState }, { coupon } = {}) {
      // const HOST = 'https://api.positivegrid.com'
      const HOST = urls.NEW_API_URL
      const url = `${HOST}/v3/ec/checkout/wechat`
      await axios({
        method: 'POST',
        headers: {
          'Authorization': `JWT ${rootState.Auth.token || window.localStorage.getItem('PG_TOKEN')}`,
          'Content-Type': 'application/json'
        },
        data: window.JSON.stringify({
          sku: state.product.sku,
          coupon
        }),
        url
      }).then((result) => {
        window.ga('ec:setAction', 'purchase', {
          id: state.product.sku,
          revenue: result.data['price'],
          coupon: state.coupon,
          tax: '0',
          shipping: '0'
        })
        window.ga('send', 'event', 'fx2-purchase', 'button')
        commit('SHOW_QR', {
          price: result.data['price'],
          originalPrice: result.data['originalPrice'],
          paymentUrl: result.data['url']
        })
      }).catch((error) => {
        console.log('errorMessage:', error.response.data.errorMessage)
      })
    },
    async getAlipaySecret ({ commit, state, rootState }, { coupon } = {}) {
      const HOST = urls.API_URL
      const url = `${HOST}/v3/ec/checkout/alipay`
      try {
        const result = await axios({
          method: 'POST',
          headers: {
            'Authorization': `JWT ${rootState.Auth.token || window.localStorage.getItem('PG_TOKEN')}`,
            'Content-Type': 'application/json'
          },
          data: window.JSON.stringify({
            sku: state.product.sku,
            coupon
          }),
          url
        })
        window.ga('ec:setAction', 'purchase', {
          id: state.product.sku,
          revenue: result.data['price'],
          coupon: state.coupon,
          tax: '0',
          shipping: '0'
        })
        window.ga('send', 'event', 'fx2-purchase', 'button')
        // commit('SHOW_ALIPAY', {
        //   price: result.data['price'],
        //   originalPrice: result.data['originalPrice'],
        //   clientSecret: result.data['clientSecret']
        // })
        /* global Stripe:true */
        const stripe = Stripe(urls.STRIPE_KEY)
        const payResp = await stripe.confirmAlipayPayment(result.data.clientSecret, {
          return_url: `${window.location.href}`
        })
        if (payResp.error) {
          throw new Error(payResp.error.message)
        }
      } catch (error) {
        console.log('errorMessage:', error.response.data.errorMessage)
      }
    },
    async getPrice ({ commit, state, rootState }, { coupon } = {}) {
      try {
        const HOST = urls.NEW_API_URL
        const url = `${HOST}/v3/ec/checkout/wechat/query`
        const result = await axios({
          method: 'POST',
          headers: {
            'Authorization': `JWT ${rootState.Auth.token || window.localStorage.getItem('PG_TOKEN')}`,
            'Content-Type': 'application/json'
          },
          data: window.JSON.stringify({
            sku: state.product.sku,
            coupon
          }),
          url
        })
        if (coupon && (result.data['price'] - result.data['upgradePrice'] === 0)) {
          commit('SET_ERROR', '请输入正确的优惠码')
        } else {
          commit('CLEAR_ERROR')
        }
        window.ga('ec:addProduct', {
          id: state.product.sku,
          name: `${state.product.name} ${state.product.version}`,
          price: String(result.data['price']),
          quantity: 1,
          category: 'Software',
          brand: 'Positive Grid',
          variant: 'Software'
        })
        window.ga('ec:setAction', 'checkout', { step: 1 })
        window.ga('send', 'event', 'fx2-purchase-query', 'button')
        commit('SET_PRICE', {
          price: result.data['price'],
          originalPrice: result.data['originalPrice'],
          upgradePrice: result.data['upgradePrice']
        })
      } catch (error) {
        if (error.response.status === 400) {
          switch (error.response.data.code) {
            case 'NOT_ALLOW_COUPON':
              commit('SET_ERROR', '优惠码不得与其他优惠併用')
              break
            case 'INVALID_COUPON':
              commit('SET_ERROR', '优惠码使用失败（错误、过期或已被使用）')
              break
            case 'PRICE_INVALID':
              commit('SET_ERROR', '优惠码使用失败（优惠金额超过产品原价)')
              break
            case 'INVALID_PARAMETER':
              break
            case 'SYSTEM_ERROR':
              break
            default:
              break
          }
        }
      }
    }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/buy-modal.js